import { IonButton, IonInput, IonLabel, IonList, IonItem, IonButtons, IonContent, IonHeader, IonMenuButton, IonPage, IonTitle, IonToolbar 
  ,IonGrid, IonModal, IonThumbnail
  ,IonRow, IonCard , IonCardSubtitle, IonCardTitle, IonCardContent
  ,IonCol, IonImg, IonCardHeader, IonAlert
  ,IonListHeader, 
  IonIcon} from '@ionic/react';

import { close, checkmark, qrCodeOutline, arrowRedo, chevronBack, closeCircle  } from 'ionicons/icons';
import React, { useState, useEffect, Component } from 'react';
//import { useParams } from 'react-router';
import './WpInspection.css';
import OpenMenuButton from "../../../components/OpenMenuButton";
import { useParams } from 'react-router';
import ServerService from '../../../services/Server';
import { useHistory } from 'react-router-dom';
import QrReader from 'react-qr-reader'
import { setAuthPersisted } from '../../../services/pinUtils';
type WpFormParams = {
  id:string, 
  dummy:string
}

const WpIns: React.FC = () => {
const server = new ServerService();
const history = useHistory();
server.setHistory(history);
const [accountName, setAccountName] = useState(server.accounts[server.activeAcc].name);
const {id, dummy} = useParams<WpFormParams>();
const [barCode, setBarcode] = useState("");
const name:string = "Site Inspection";
const [wpList, setWpList] = useState([]);
const [showModal, setShowModal] = useState(false);
const [processIcon, setProcessIcon] = useState("");
const [conIcon, setConIcon] = useState("");
const [closeIcon, setCloseIcon] = useState("");
const [resultStatus, setResultStatus] = useState("");
const [showQrScan, setShowQrScan] = useState(true);
const [qrReader, setQrReader] = useState("");
const [showAlert1, setShowAlert1] = useState(false);
const [alertMsg, setAlertMsg] = useState("");

const onScanQr = function(status:any) {
  setShowQrScan(false);
}
const onClickBarcodeQR = function(qr:any) {
  //setBarcode(qr);
  var result =  fetchWorkStatus(qr);
}
const onClickBarcode = function(status:any) {
  
  var result =  fetchWorkStatus(barCode);
  console.log(result);
  //setShowModal(true);
  //setProcessIcon(checkmark);
  
  /*if(resultStatus == 'P'){
    setProcessIcon(checkmark);
  }
  if(resultStatus == 'R'){
    setProcessIcon(checkmark);
    setConIcon(checkmark);
    setCloseIcon(checkmark);
  }
  if(resultStatus == 'C'){
    setProcessIcon(checkmark);
    setConIcon(checkmark);
    setCloseIcon(checkmark);
  }*/

  //window.location.href = "/page/home/wp/wpQc/"+barCode+"/d";
}

const onLoadStatus = async function(result:any, qr:any) {
  console.log('onLoadStatus');
  setResultStatus(result.status);
  console.log(result.status);
  if(result.status == 'WP' || result.status == 'P1'){
    setAuthPersisted();
    window.location.href = "/page/home/wp/wpQc/"+qr+"/d";
  }else if(result.status=='C'){
    setAlertMsg('ตรวจสอบเรียบร้อยแล้ว');
    setShowAlert1(true);
    
  }else{
    setAlertMsg('ไม่พบข้อมูล');
    setShowAlert1(true);
    
  }
  console.log(alertMsg);
}
const onSelectItem = function(status:any) {
  //if(resultStatus=='A' || resultStatus=='WP'){
    setAuthPersisted();
    window.location.href = "/page/home/wp/wpQc/"+barCode+"/d";
  //}
}
const onSelectCardItem = function(id:any) {

  setBarcode(id);
  setAuthPersisted();
  window.location.href = "/page/home/wp/wpQc/"+id+"/d";
  //var result = fetchWorkStatus(id);
  //console.log(result);
  //setShowModal(true);
 
}
const fetchWorkStatus = async function(id:any) {
  const data = {
    docid: id
  }
   await fetch(server.getFullUrl("wp/mb/getWorkStatus", data),server.getRequest())
  .then(res => res.json()
  .then(
    (result) => {
      console.log('fetchFlagStatus');
      //setResultStatus(result.status);

      
      onLoadStatus(result, id);
      //setAlertMsg("");
     // console.log(result.status);
     // return result;
    },
    (error) => {
      setResultStatus("");
    }
 ).catch(e => {

 })
).catch(e => {

})
 
}
const fetchWp = function(status:any) {

  fetch(server.getFullUrl("wp/mb/listQcDocument", null),server.getRequest())
  .then(res => res.json()
  .then(
    (result) => {
      setWpList(result.qcdoclist);
      console.log('fetchWp');
    },
    (error) => {

    }
 ).catch(e => {

 })
).catch(e => {

}) 
}
useEffect(() => {
  fetchWp("");
}, [])

useEffect(() => {
  //setAlertMsg(alertMsg);
  console.log('Eff Alert');
  console.log(alertMsg);
}, [alertMsg])
const handleScan = (data: any) => {
  //setShowAlert(true);
  //setQrReader(data);
  if (data!=null && data != '') {
   setShowQrScan(true);
   setBarcode(data);
  
   //setAlertMsg(data);
   //setShowAlert1(true);
   //window.location.href = "/page/home/wp/wpQc/"+data+"/d";
   
   onClickBarcodeQR(data);
  
  }
  
 
}

const handleError = (err: any) => {
 console.error(err)
}
const onDownloadWork = function(id:any, jsaId:any) {

  window.open(server.getFullUrl("wp/printWork?alf_ticket="+server.state.ticket+"&jsa_id="+jsaId+"&permit_id="+id, null));
 
}

  return (
    <IonPage>
       <IonHeader>
        <IonToolbar>    
          <IonButtons slot="start">
            <IonMenuButton />
            <OpenMenuButton />
          </IonButtons>      
         <div>
          <img className="insImg1" src={"assets/img/check-icon.png"}/> 
          <span className="insSpan">  {name}</span>
         </div>
        </IonToolbar>
      </IonHeader>


      <IonContent>
      <IonAlert
          isOpen={showAlert1}
          onDidDismiss={() => setShowAlert1(false)}
          className='my-custom-class'
          header={barCode}
          subHeader={alertMsg}
          //message={'This is an alert message.'}
          buttons={['OK']}
        />
      <IonModal isOpen={!showQrScan}>
      <IonListHeader>
      <IonLabel>Scan QR Code</IonLabel>
      <IonButton onClick={() => setShowQrScan(true)}><IonIcon icon={closeCircle}></IonIcon></IonButton>
      </IonListHeader>
    
        <IonContent>
        
        <div hidden={showQrScan}>
          <QrReader
            delay={1000}
            onError={handleError}
            onScan={handleScan}
            resolution={1200}
            style={{ width: '100%' }}
          />
        </div>
        </IonContent>
      </IonModal>
      <IonModal isOpen={showModal}>
      <IonHeader>

        <IonItem>
        
        <IonButton  color="light"  onClick={() => setShowModal(false)}> <IonIcon icon={chevronBack}></IonIcon></IonButton>
      <IonTitle className="title">ขั้นตอนการตรวจสอบ</IonTitle>
        </IonItem>

           
      </IonHeader>

      <IonContent>
      <IonList>
        <IonItem onClick={() => onSelectItem(processIcon)}>
        <IonIcon slot="end" icon={processIcon}></IonIcon>
         <IonLabel>ปฎิบัติงาน</IonLabel>
        </IonItem>
        <IonItem onClick={() => onSelectItem(conIcon)}>
        <IonIcon slot="end" icon={conIcon}></IonIcon>
         <IonLabel>ต่ออายุงาน</IonLabel>
        </IonItem>
        <IonItem onClick={() => onSelectItem(closeIcon)}>
        <IonIcon slot="end" icon={closeIcon}></IonIcon>
         <IonLabel>ปิดงาน</IonLabel>
        </IonItem>
       </IonList>
      </IonContent>
      
        
       
      </IonModal>
      <IonList>
        <IonItem>
            <IonLabel className="f-header p1" position="stacked">Barcode</IonLabel>
            <IonInput value={barCode} onIonChange={e => {setBarcode(e.detail.value)}}> </IonInput>
          </IonItem>
        </IonList>
        <IonGrid>
  <IonRow>
    <IonCol>
      <IonButton color="secondary" expand="block" onClick={(e) => onScanQr("")}><IonIcon icon={qrCodeOutline}></IonIcon> <IonLabel>Scan QR</IonLabel></IonButton>
    </IonCol>
    <IonCol>
    <IonButton color="primary" expand="block" onClick={(e) => onClickBarcode("")}><IonIcon icon={arrowRedo}></IonIcon>Submit</IonButton>
    </IonCol>
  </IonRow>
</IonGrid>
  
  
    <IonList>
    {wpList.map((task,i) => {
          return(
          
            <IonItem key={i}>
            <IonThumbnail slot="start">
              <IonImg src={"assets/img/"+task.img+".png"} />
            </IonThumbnail>
            <IonCard>
              <IonCardHeader onClick={() => onSelectCardItem(task.docid)}>
                <IonCardTitle>{task.docid}</IonCardTitle>
                <IonCardSubtitle>{task.authorcompany}</IonCardSubtitle>
            
              </IonCardHeader>
             
              <IonCardContent onClick={() => onSelectCardItem(task.docid)}>
                <h2>สถานที่ปฏิบัติงาน : {task.worklocation}</h2>
                <h2>พื่นที่ : {task.flagshareareaname}</h2>
                <h2>ทำงานวันที่ : {task.workdate} </h2>
                <h2>อาคาร : {task.workbuilding} ชั้น : {task.workfloor}</h2>
                <h2>ทำงานวันที่ : {task.workdate} </h2>
              </IonCardContent>
              <IonButton routerLink={"/page/home/wp/wpDtl/"+task.docid+"/"+dummy} fill={"clear"}> <img className="img1" src={"assets/img/file.png"} />View</IonButton>
              <IonButton onClick={() => onDownloadWork(task.docid,task.jsa_id)}  fill={"clear"}> <img className="img1" src={"assets/img/pdf-document.png"} />&nbsp;PDF</IonButton>
            
              </IonCard>
          </IonItem>
    )})}
    </IonList>
 

      </IonContent>

    </IonPage>
  );
};

export default WpIns;
